

import type { AutopilotState } from '../domain/panel';
export type { AutopilotConfig, AutopilotState } from '../domain/panel';

export const TASK_STATUS_LABEL: Record<string, string> = {
  run: 'выполняется',
  pause: 'пауза',
  stop: 'стоп',
  not_found: 'не найден в поиске',
};

export type AutopilotStep = { id: string; title: string; active: boolean };

export function autopilotSteps(p: AutopilotState): AutopilotStep[] {
  const phase = p.phase || 'idle';
  const running = p.status === 'running';
  const ready = p.readyNow || 0;
  const need = p.nextTaskNeed || 0;
  const quota = p.quotaRemaining || 0;
  return [
    {
      id: 'farm',
      title: 'Мало готовых под оставшийся план — прогрев',
      active: running && phase === 'farm' && quota > 0 && ready < (need || quota),
    },
    {
      id: 'target',
      title: 'Готовых хватает — работа по задачам',
      active: running && phase === 'target',
    },
    {
      id: 'loop',
      title:
        p.message && running && quota <= 0 && phase !== 'target' ? p.message : 'Нет открытой квоты — прогрев выключен',
      active: running && quota <= 0 && phase !== 'target',
    },
    {
      id: 'farm-ready',
      title: 'Есть квота, готовых достаточно — сейчас переключаюсь на задачи',
      active: running && phase === 'farm' && quota > 0 && ready >= (need || quota),
    },
  ];
}
